import { configureStore } from "@reduxjs/toolkit";
import { documentosSlice } from "./pages/documentos/documentosSlice";
import { notasServicoSlice } from "./pages/nf/nfse/emissao/notasServicoSlice";
import { insumosLocalSlice } from "./pages/insumos/locais/InsumosLocalSlice";

export const store = configureStore({
    reducer: {
        uiDocumentos: documentosSlice.reducer,
        uiNotasServico: notasServicoSlice.reducer,
        uiInsumosLocal: insumosLocalSlice.reducer,
    }
})